import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from "../../Assets/Images/logo.png";
import cart from "../../Assets/Images/cart.svg";
import { CiSearch } from "react-icons/ci";
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import userimg from '../../Assets/Images/user.png'
import { logout } from '../../Redux/Slice/Auth/authSlice';
import { removeAllCart, removeFromCart } from '../../Redux/Slice/Cart/cartSlice';

const Header = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token, data } = useSelector((state) => state.auth);
    // const token = localStorage.getItem("access_token")

    console.log("first user", data)
    console.log("token", token)

    const handleLogout = async () => {
        dispatch(logout());
        dispatch(removeAllCart())
        navigate('/login')
    }

    const cartItems = useSelector(state => state.cart)

    const cartItemsLenght = cartItems?.cart?.length

    return (
        <Navbar collapseOnSelect expand="lg" className="">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <img src={logo} className='logo' alt="" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">Home</Nav.Link>
                        <Nav.Link as={Link} to="/about-us">About Us</Nav.Link>
                        <Nav.Link as={Link} to="/shop">Shop</Nav.Link>
                        <Nav.Link as={Link} to="/books">Books</Nav.Link>
                        <Nav.Link as={Link} to="/subscription">Subscription box</Nav.Link>
                        <Nav.Link as={Link} to="/contact-us">Contact us</Nav.Link>

                    </Nav>
                    <Nav>
                        <Form className="d-flex">
                            <div className=" d-flex bg-light rounded-2 me-2 px-2 align-items-center">
                                <Form.Control

                                    type="search"
                                    placeholder="Search"
                                    className="me-2 bg-transparent border-0"
                                    aria-label="Search"
                                />
                                <div>
                                    <CiSearch size={22} />
                                </div>
                            </div>
                        </Form>
                        <Link className='text-white btn btn-light me-2 align-items-center d-flex' to={"/my-cart"}>
                            {/* <button className='btn btn-light me-2' style={{ height: '100%' }}> */}
                            <div className='position-relative'>

                                <img src={cart} width={18} alt="" />

                                {cartItemsLenght > 0 ? (
                                    <span className='position-absolute top-0 start-100 translate-middle bg-danger rounded-circle d-flex justify-content-center align-item-center s-12' style={{ height: "18px", width: "18px" }}>{cartItemsLenght}</span>
                                ) : ""}
                            </div>
                            {/* </button> */}
                        </Link>
                        {
                            !token ? (
                                <>

                                    <button className='btn btn-danger'>
                                        <Link className='text-white' to={"/sign-up"}>
                                            Create account
                                        </Link>
                                    </button>
                                </>
                            ) : (
                                <>

                                    <Dropdown>
                                        <Dropdown.Toggle variant="danger" className='text-capitalize' id="dropdown-basic">
                                            {
                                                data?.userimg ? (

                                                    < img className='rounded-circle ' width={45} height={45} src={data?.userimg} alt="" />
                                                ) : (

                                                    <img className='rounded-circle ' width={45} height={45} src={userimg} alt="" />
                                                )
                                            }

                                            {" "} {data?.name} 
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item as={Link} to="/my-profile">My Profile </Dropdown.Item>
                                            <Dropdown.Item onClick={handleLogout} >Logout </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </>
                            )
                        }

                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header